module.exports = __webpack_public_path__ + "img/crypto-eth.e0c34b9b.svg";